import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { BUSINESS } from "@/data/business";

export default function Privacy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      crumbName="Privacy Policy"
      path="/privacy-policy"
      description="JK House Cleaning privacy policy. How we collect, use and protect your personal information in line with Australian privacy principles."
    >
      <p>
        {BUSINESS.name} (ABN {BUSINESS.abn}) is committed to protecting your privacy. This policy explains how
        we collect, use, store and protect the personal information you provide when requesting a quote or using
        our services. We handle your information in accordance with the Australian Privacy Principles.
      </p>

      <LegalSection heading="Information we collect">
        <p>When you request a quote or contact us, we may collect your name, phone number, email address,
          property details, cleaning preferences, access arrangements, any photos you choose to upload, and any
          notes you provide.</p>
      </LegalSection>

      <LegalSection heading="How we use your information">
        <p>We use your information solely to prepare your quote, arrange and deliver your cleaning service,
          communicate with you, and manage our customer relationship. We do not use your information for
          unrelated purposes.</p>
      </LegalSection>

      <LegalSection heading="Your quote information stays private">
        <p>All quote information and uploaded photos are kept private and confidential. They are stored securely
          and are never publicly accessible. Uploaded images can only be viewed by authorised staff through our
          secure admin system.</p>
      </LegalSection>

      <LegalSection heading="We never sell your information">
        <p>We do not sell, rent or trade your personal information to any third party. We only share information
          where necessary to deliver our service, or where required by law.</p>
      </LegalSection>

      <LegalSection heading="Data security">
        <p>We take reasonable steps to protect your personal information from misuse, loss and unauthorised
          access, including secure storage and restricted access to customer records.</p>
      </LegalSection>

      <LegalSection heading="Access and corrections">
        <p>You may request access to the personal information we hold about you, or ask us to correct it, by
          contacting us at {BUSINESS.email} or on {BUSINESS.phoneDisplay}.</p>
      </LegalSection>

      <LegalSection heading="Contact us">
        <p>If you have any questions about this Privacy Policy, please contact {BUSINESS.name} at {BUSINESS.email}
          or {BUSINESS.phoneDisplay}.</p>
      </LegalSection>
    </LegalLayout>
  );
}
